import { useEffect, useState } from "react";
import { PubTournament, TimerInfoState } from "../../../../../api/types";
import {
  CircularProgress,
  TournamentStateInfoBlindWrapper,
  TournamentStateInfoLevelWrapper,
  TournamentStateInfoTimerWrapper,
  TournamentStateInfoWrapper,
} from "./styled";
import {
  calculateTimeAtStart,
  calculateTimes,
} from "../../../../../utils/timer";
import { currentTimeState } from "../../../../../recoil/app";
import { useRecoilValue } from "recoil";

interface TournamentStateInfoProps {
  tournament: PubTournament;
  updateData: () => void;
}
const TournamentStateInfo = ({
  tournament,
  updateData,
}: TournamentStateInfoProps) => {
  const radius = 28.5;
  const circumference = 2 * Math.PI * radius;
  const currentTime = useRecoilValue(currentTimeState);
  const [timer, setTimer] = useState<TimerInfoState>();

  useEffect(() => {
    if (!tournament) return;

    if (tournament.timerDto) {
      const time = calculateTimes(tournament.timerDto, tournament.structure);
      if (time && time.overStack < 1) {
        setTimer(time);
      }
    } else {
      const startDate = new Date(tournament.startDate);
      const time = calculateTimeAtStart(
        startDate,
        new Date(tournament.createdAt),
        tournament.structure[0],
        tournament.structure[1]
      );
      setTimer(time);
    }
  }, [tournament, currentTime]);

  const formatTime = (value: string | undefined) => {
    if (!value) return "";
    if (value.includes("hour")) {
      if (+value.split("hour")[0] <= 24) {
        return value;
      }
      const day = (+value.split("hour")[0] / 24).toFixed();
      return `${day}day`;
    }
    return value;
  };

  const getEntryButtonText = (): string => {
    const totalCapacity =
      tournament.adOnUserCount +
      tournament.entryUserCount +
      tournament.reBuyInUserCount;

    return `${tournament.userCount}/${totalCapacity}`;
  };

  return (
    <TournamentStateInfoWrapper>
      {timer && (
        <>
          <TournamentStateInfoTimerWrapper
            progress={timer?.progress ? timer?.progress : 0}
          >
            <div className="time-box">
              <CircularProgress>
                <circle className="background" r={28.5} cx="28.5" cy="28.5" />
                <circle
                  className="progress"
                  r={28.5}
                  cx="28.5"
                  cy="28.5"
                  stroke="url(#gradient)"
                  strokeWidth="5"
                  strokeDasharray={circumference}
                  strokeDashoffset={
                    timer.currentLevel.type === "READY"
                      ? 0
                      : (circumference * -timer.progress) / 100
                  }
                />
                <defs>
                  <radialGradient
                    id="gradient"
                    cx="95%"
                    cy="50%"
                    r="80%"
                    fx="100%"
                    fy="50%"
                  >
                    <stop offset="0%" stopColor="#FFFFFF" />
                    <stop offset="49.5%" stopColor="#FF8787" />
                    <stop offset="100%" stopColor="#FF0000" />
                  </radialGradient>
                </defs>
              </CircularProgress>
              <div className="time">
                {formatTime(timer.remainingTimeInCurrentLevel)}
              </div>
            </div>
            <TournamentStateInfoLevelWrapper>
              <div className="lv">
                {tournament.isEnd
                  ? "종료된 토너먼트"
                  : timer.currentLevel.type === "BREAK"
                  ? "BREAK"
                  : timer.currentLevel.type === "READY"
                  ? "준비중"
                  : `LV ${timer.currentLevel.level}`}
              </div>
              <div className="entry">현재 엔트리 {getEntryButtonText()}</div>
            </TournamentStateInfoLevelWrapper>
            <img
              src="/image-web/tournament/reset.svg"
              alt="reset"
              onClick={() => updateData()}
            />
          </TournamentStateInfoTimerWrapper>
          <TournamentStateInfoBlindWrapper>
            <div className="item">
              <div className="name">
                {`${
                  timer.currentLevel.type === "READY" ? "시작" : "현재"
                } BLIND`}{" "}
              </div>
              <div className="blind">
                {timer.currentLevel.type === "BREAK"
                  ? "BREAK"
                  : `${timer.currentLevel.smallBlind} / ${timer.currentLevel.bigBlind} (${timer.currentLevel.ante})`}
              </div>
            </div>
            <div className="item">
              <div className="name">다음 BLIND</div>
              <div className="blind">
                {timer.nextLevel?.type === "BREAK"
                  ? "BREAK"
                  : `${timer.nextLevel?.smallBlind} / ${timer.nextLevel?.bigBlind} (${timer.nextLevel?.ante})`}
              </div>
            </div>
            <div className="item">
              <div className="name">레지 마감</div>
              <div className="blind">{tournament.registerDeadlineLevel}LV</div>
            </div>
          </TournamentStateInfoBlindWrapper>
        </>
      )}
    </TournamentStateInfoWrapper>
  );
};

export default TournamentStateInfo;
